const SESSION_CHECK_TIMEOUT_MS = 10_000;

export const SESSION_RETRY_DELAYS_MS = [250, 750, 1500] as const;

export function isTransientSessionError(error: unknown): boolean {
  const candidate = error as { isAcquireTimeout?: boolean; message?: string } | null;
  if (candidate?.isAcquireTimeout) return true;
  const message = candidate?.message ?? '';
  return (
    message.includes('Acquiring an exclusive Navigator LockManager lock') ||
    message.includes('Session check timed out') ||
    message.includes('lock') && message.includes('timed out') ||
    message.includes('Failed to fetch') ||
    message.includes('NetworkError')
  );
}

export function isRefreshTokenError(message: string): boolean {
  return (
    message.includes('Refresh Token Not Found') ||
    message.includes('Invalid Refresh Token') ||
    message.includes('refresh_token_not_found')
  );
}

export async function withSessionTimeout<T>(request: Promise<T>, timeoutMs = SESSION_CHECK_TIMEOUT_MS): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      request,
      new Promise<never>((_, reject) => {
        timeoutId = setTimeout(() => reject(new Error('Session check timed out')), timeoutMs);
      }),
    ]);
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}